/**
 * Box type filtering rules for shipment containers and packages.
 *
 * A box type is a pallet box type when its key (shipmentBoxTypeId) starts with
 * PALLET_BOX_TYPE_PREFIX.
 * The backend applies the same rule in
 * mantle.shipment.ShipmentContainerServices.check#ContainerBoxTypeValid
 *
 * Pallet containers accept only pallet box types. All other container types
 * (cartons, legacy packages, ...) accept everything except pallet box types.
 *
 * When the shipment does not allow pallet packing (non-freight gateway / method),
 * pallet box types are hidden regardless of container kind.
 */
export var PALLET_BOX_TYPE_PREFIX = 'BtPallet';
export var PALLET_CONTAINER_TYPE_ID = 'CtPallet';
export var isPalletContainerType = function (containerTypeEnumId) {
    return containerTypeEnumId === PALLET_CONTAINER_TYPE_ID;
};
export var boxKindForContainerType = function (containerTypeEnumId) {
    return isPalletContainerType(containerTypeEnumId) ? 'pallet' : 'carton';
};
/** ID starts with the BtPallet prefix. Matches the backend's check#ContainerBoxTypeValid rule */
export var isPalletBoxType = function (boxType) { return boxType.key.startsWith(PALLET_BOX_TYPE_PREFIX); };
export var filterBoxTypesForContainer = function (boxTypes, kind, options) {
    if (options === void 0) { options = {}; }
    var byKind = kind === 'pallet' ? boxTypes.filter(function (b) { return isPalletBoxType(b); }) : boxTypes.filter(function (b) { return !isPalletBoxType(b); });
    return options.allowsPallet === false ? byKind.filter(function (b) { return !isPalletBoxType(b); }) : byKind;
};
/** Box types selectable for a package/container with no known kind (legacy packing, unlinked packages). */
export var filterBoxTypesForShipment = function (boxTypes, options) {
    if (options === void 0) { options = {}; }
    return (options.allowsPallet === false ? boxTypes.filter(function (b) { return !isPalletBoxType(b); }) : boxTypes);
};
